'use strict';

var base = require('base/search/search');

function toggleFilterDrawer() {
    const toggle = document.getElementById('toggle-filter-drawer');
    const filterDrawer = document.getElementById('filter-drawer');
    if (toggle && filterDrawer) {
        toggle.addEventListener('click', () => {
            filterDrawer.classList.toggle('collapsed');
            toggle.classList.toggle('collapsed');
        });
    }
}

base.markViewedProducts = function () {
    var viewedProducts = JSON.parse(sessionStorage.getItem('viewed_products')) || [];
    viewedProducts.forEach(function (productId) {
        $('.viewed-badge[data-pid="' + productId + '"]').removeClass('d-none');
    });
};

/**
 * Set cookie value
 * @param {string} cookieName - selected sort option
 * @param {string} cookieValue - selected sort option
 * @param {string} expiryDays - selected sort option
 */
function setCookie(cookieName, cookieValue, expiryDays) {
    const d = new Date();
    d.setTime(d.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
}

/**
 * Initialize Grid Size Selector Elements
 * @param {string} gridSizeSelectorBtn - selected sort option
 * @param {string} gridTwoUpBtnIcon - selected sort option
 * @param {string} squareBtnIcon - selected sort option
 * @return {Object} - grid size button DOM elements
 */
function initializeGridSizeElements() {
    var gridSizeSelectorBtn = document.querySelector('.grid-size-selector .grid-size-btn');
    var gridTwoUpBtnIcon = document.querySelector('.grid-size-selector .grid-size-btn .grid-2-btn i');
    var squareBtnIcon = document.querySelector('.grid-size-selector .grid-size-btn .square-btn i');

    return {
        gridSizeSelectorBtn: gridSizeSelectorBtn,
        gridTwoUpBtnIcon: gridTwoUpBtnIcon,
        squareBtnIcon: squareBtnIcon
    };
}

/**
 * Update product grid size on PLP and result page
 * @param {string} gridSize - gridSize value 'small' or 'large'
 */
function updateProductGridSize(gridSize) {
    var productGrids = document.querySelectorAll('.product-grid > div:not(.grid-footer)');

    productGrids.forEach(function (productGrid) {
        if (gridSize === 'large') {
            productGrid.classList.add('col-12');
            productGrid.classList.remove('col-6');
        } else {
            productGrid.classList.add('col-6');
            productGrid.classList.remove('col-12');
        }
    });
}

/**
 * Update grid size selector UI and set product grid size preference to large
 * @param {Object} elements - DOM elements for grid selector button
 */
function setGridSizePreferenceLarge(elements) {
    if (elements.gridSizeSelectorBtn) {
        setCookie('customerPLPGridSizePreference', 'large', 30);
        elements.gridSizeSelectorBtn.setAttribute('aria-checked', 'true');
        elements.gridTwoUpBtnIcon.classList.remove('fa-solid');
        elements.gridTwoUpBtnIcon.classList.add('fa-regular');
        elements.squareBtnIcon.classList.remove('fa-regular');
        elements.squareBtnIcon.classList.add('fa-solid');
        updateProductGridSize('large');
    }
}

/**
 * Update grid size selector UI and set product grid size preference to small
 * @param {Object} elements - DOM elements for grid selector button
 */
function setGridSizePreferenceSmall(elements) {
    if (elements.gridSizeSelectorBtn) {
        setCookie('customerPLPGridSizePreference', 'small', 30);
        elements.gridSizeSelectorBtn.setAttribute('aria-checked', 'false');
        elements.gridTwoUpBtnIcon.classList.remove('fa-regular');
        elements.gridTwoUpBtnIcon.classList.add('fa-solid');
        elements.squareBtnIcon.classList.remove('fa-solid');
        elements.squareBtnIcon.classList.add('fa-regular');
        updateProductGridSize('small');
    }
}

if (document.querySelector('.grid-size-selector')) {
    var elements = initializeGridSizeElements();

    // Toggle product grid size selector when button is clicked
    elements.gridSizeSelectorBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (elements.gridSizeSelectorBtn.getAttribute('aria-checked') === 'true') {
            setGridSizePreferenceSmall(elements);
        } else {
            setGridSizePreferenceLarge(elements);
        }
    });
}

function observeStickyHeader() {
    const el = document.querySelector('.grid-header');

    if (el) {
        const observer = new IntersectionObserver(([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1), { rootMargin: '-98.6px 0px 0px 0px', threshold: [1] }); // rootMargin set to offset the mobile navigation height

        observer.observe(el);
    }
}

let priceFilterList = $('.filter__refinementulprice--style .filter__pricerefinementvalue--style span[aria-hidden="true"]').last();
let maxValuePrice = 1000;
var searchURL = null;
if ($(priceFilterList).length > 0) {
    let priceFilterValues = $(priceFilterList).text().trim().split('-');

    if (priceFilterValues.length > 0) {
        maxValuePrice = parseInt(priceFilterValues[1].trim(), 10) + 1;
    }
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);

    $(selector).empty().html($updates.html());
    $('body').trigger('search:updateDom', selector);
    if ($updates.hasClass('refinements')) {
        if (!searchURL) {
            searchURL = $updates.find('.refinement .content .values button').data('href');
        }
        history.replaceState('Search', document.title, decodeURIComponent(searchURL.replace('Ajax', '')));
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}
/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.refinement-bar__show-button'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    toggleFilterDrawer();
}

/**
 * Update param in url
 *
 * @param {string} url - url to be updated
 * @param {string} paramName - param to be updated
 * @param {string} paramValue - value to be updated
 * @return {string} - search result url
 */
function replaceUrlParam(url, paramName, paramValue) {
    let tempParamValue = paramValue;
    let tempUrl = url;
    if (tempParamValue == null) {
        tempParamValue = '';
    }
    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
    if (tempUrl.search(pattern) >= 0) {
        return tempUrl.replace(pattern, '$1' + tempParamValue + '$2');
    }
    tempUrl = tempUrl.replace(/[?#]$/, '');
    return tempUrl + (tempUrl.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + tempParamValue;
}

/**
 * Update Filter values after result appear
 *
 * @param {string} minV - current min value from the interval
 * @param {string} maxV - current max value from the interval
 * @param {string} maxPriceFilter - Max Price Filter value
 * @return {undefined}
 */
function parseResultsCustomPrice(minV, maxV, maxPriceFilter) {
    $('.range-min').val(minV);
    $('.range-max').val(maxV);
    $('.input-min').val(minV);
    $('.input-max').val(maxV);
    $('.range-min').attr('max', maxPriceFilter);
    $('.range-max').attr('max', maxPriceFilter);
    $('.price-interval .price-interval-max').empty().text('$' + maxPriceFilter);
    $('.price-placeholder .price-placeholder-min span').empty().text('$' + minV);
    $('.price-placeholder .price-placeholder-max span').empty().text('$' + maxV);
    $('.price-placeholder .price-placeholder-min').css('left', ((minV / maxPriceFilter) * 100) + '%');
    $('.price-placeholder .price-placeholder-max').css('right', (100 - ((maxV / maxPriceFilter) * 100)) + '%');
    $('.slider .progress').css('left', ((minV / maxPriceFilter) * 100) + '%');
    $('.slider .progress').css('right', (100 - ((maxV / maxPriceFilter) * 100)) + '%');
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Check if there are filters selected. If yes it will show the clear results button
 *
 */
function validateClearResults() {
    var urlParams = new URLSearchParams(location.href);
    if ($('.filter__button--style.filter__button--active, .filter__box--style.filter__box--active, .color-attribute .selected').length > 0 ||
        $('.range-min').val() !== $('.range-min').attr('min') ||
        (urlParams.get('pmin') && urlParams.get('pmin') !== $('.range-min').attr('min')) ||
        $('.range-max').val() !== $('.range-max').attr('max') ||
        (urlParams.get('pmax') && urlParams.get('pmax') !== $('.range-min').attr('max'))) {
        $('.refinement-bar .secondary-bar').removeClass('d-none');
    } else {
        $('.refinement-bar .secondary-bar').addClass('d-none');
    }
}

/**
 * Check if there is a sort rule in the URL params. If so, make sure sort dropdown has the correct sort option selected
 *
 */
function updateSortDropDown() {
    let params = new URLSearchParams(document.location.search);
    let sortRule = params.get('srule');
    if (sortRule !== null) {
        let sortDropDown = document.querySelector('.custom-select.sort-order');

        let currentlySelectedOption = sortDropDown.options[sortDropDown.selectedIndex];

        if (currentlySelectedOption.className !== sortRule) {
            currentlySelectedOption.removeAttribute('selected');
        }

        let selectedOption = sortDropDown.querySelector(`.${sortRule}`);
        if (selectedOption) {
            selectedOption.setAttribute('selected', '');
        }
    }
}

/**
 * Update the filer URL with sort rule selected parameter
 *
 * @param {string} url - filter url
 * @param {string} param - sort rule key
 * @param {string} value - sort rule value
 * @return {string} - search result url
 */
function updateUrlParameter(url, param, value) {
    var urlParts = url.split('?');
    var baseUrl = urlParts[0];
    var queryString = urlParts[1] || '';
    var newQueryString = '';
    var paramRegex = new RegExp('(^|&)' + param + '=([^&]*)');

    if (queryString.match(paramRegex)) {
        // If the parameter exists, remove it add selected sort parameter
        var updatedQueryString = queryString.replace(paramRegex, '').replace(/^&|&$/, '');
        newQueryString = updatedQueryString + '&' + param + '=' + value;
    } else {
        // If the parameter doesn't exist, add it
        newQueryString = queryString + '&' + param + '=' + value;
    }

    return baseUrl + '?' + newQueryString;
}

/**
 * Update the selected sort rule in dropdown
 * @param {string} parameter - selected sort option
 */
function selectSortOption(parameter) {
    var selectElement = $('#sortOrderSelect');

    // Find the option with the given data-id attribute value
    var newOption = selectElement.find('option[data-id="' + parameter + '"]');

    if (newOption.length) {
        // Deselect the currently selected option
        selectElement.find('option:selected').prop('selected', false);
        newOption.prop('selected', true);
        selectElement.trigger('change');
    }
}

base.applyFilter = function () {
    // Handle refinement value selection and reset click
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .filter-reset-btn button',
        function (e) {
            e.preventDefault();
            e.stopPropagation();
            let url = $(this).data('href');
            var selectedSortOption = $('.custom-select.sort-order').find('option:selected').data('id');
            // update the filer url with sort rule parameter
            url = updateUrlParameter(url, 'srule', selectedSortOption);
            let min;
            let max;
            if (!$(this).hasClass('reset')) {
                min = $('.range-min').val();
                max = $('.range-max').val();
                url = replaceUrlParam(url, 'pmin', min);
                url = replaceUrlParam(url, 'pmax', max);
            } else {
                min = $('.range-min').attr('min');
                max = $('.range-max').attr('max');
            }
            $.spinner().start();
            $(this).trigger('search:filter', e);
            var attributeId = '#' + $(this).find('span').last().attr('id');
            searchURL = url;

            $.ajax({
                url: url,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: url
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    parseResultsCustomPrice(min, max, maxValuePrice);
                    validateClearResults();
                    selectSortOption(selectedSortOption);
                    $.spinner().stop();
                    $(attributeId).parent('button').focus();
                },
                error: function () {
                    $.spinner().stop();
                    $(attributeId).parent('button').focus();
                }
            });
        });
};

base.showMore = function () {
    // Show more products
    $('.container').on('click', '.show-more button', function (e) {
        e.stopPropagation();
        var showMoreUrl = $(this).data('url');
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: {
                selectedUrl: showMoreUrl
            },
            method: 'GET',
            success: function (response) {
                $('.grid-footer').replaceWith(response);
                base.markViewedProducts();
                updateSortOptions(response);
                $('.resultsNo-pagesize').text($('.search-keywords').text().trim().replace(/[“”]/g, '') + ' ( ' + $('.product-tile').length + ' of ' + $('.search-result-count').text().trim().toLowerCase().replace(/[^\d,]/g, '') + ' ) ');
                var urlParams = new URLSearchParams(showMoreUrl);
                var start = parseInt(urlParams.get('start'), 10);
                var sz = parseInt(urlParams.get('sz'), 10);
                if (start && sz) {
                    var newSearchURL = replaceUrlParam(location.href, 'sz', sz + start);
                    newSearchURL = replaceUrlParam(newSearchURL, 'start', '0');
                    history.replaceState('Search', document.title, decodeURIComponent(newSearchURL));
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

base.sort = function () {
    // Handle sort order menu selection
    $('.container').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();
        if (this.value.toLocaleLowerCase().replace(' ', '') !== 'sortby') {
            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: {
                    selectedUrl: this.value
                },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
};

base.filter = function () {
    // Display refinements bar when Menu icon clicked
    $('.container').on('click', 'button.filter-results', function () {
        $('.refinement-bar, .modal-background').show();
        $('.refinement-bar').addClass('open');
        $('.refinement-bar').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
        $('.refinement-bar .close').focus();
    });
};

base.closeRefinements = function () {
    // Refinements close button
    $('.container').on('click', '.refinement-bar button.close, .modal-background, .refinement-bar .clearfix-close', function () {
        $('.refinement-bar').removeClass('open');
        $('.refinement-bar, .modal-background').delay(400).hide();
        $('.refinement-bar').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        $('.btn.filter-results').focus();
    });

    // This code would be placed in the method that opens the modal/menu:
    $('.container').on('keyup', function (event) {
        if (event.keyCode == 27) {
            $('.refinement-bar').removeClass('open');
            $('.refinement-bar, .modal-background').delay(400).hide(400);
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        }
    });
};

base.showProductTileAltImage = function () {
    $('body').on('mouseover', '.product-tile .image-container .tile-image--primary', function () {
        let image = $(this);
        if ($(image).attr('data-secondary-src') !== '' && $(image).attr('data-secondary-srcset') !== '') {
            $(image).attr('src', $(image).attr('data-secondary-src'));
            $(image).attr('srcset', $(image).attr('data-secondary-srcset'));
        }
    });
};

base.showProductTileFirstImage = function () {
    $('body').on('mouseout', '.product-tile .image-container .tile-image--primary', function () {
        let image = $(this);
        $(image).attr('src', $(image).attr('data-primary-src'));
        $(image).attr('srcset', $(image).attr('data-primary-srcset'));
    });
};

base.showProductTileSwatchImage = function () {
    $('body').on('click', '.product-tile .swatch--color__action', function (e) {
        e.preventDefault();
        var swatchTrigger = $(this);
        let params = $(this).data('params');
        if (params) {
            params = '&' + params;
        }
        $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('.image-container').spinner().start();
        $.get($(swatchTrigger).data('action') + params, function (data) {
            $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('img.tile-image--primary').attr('src', data.images['hi-res'][0].mobile);
            $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('img.tile-image--primary').attr('srcset', data.images['hi-res'][0].mobile + ' 300w, ' + data.images['hi-res'][0].mobile2x + ' 600w');
            $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('img.tile-image--primary').attr('data-primary-src', data.images['hi-res'][0].mobile);
            $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('img.tile-image--primary').attr('data-primary-srcset', data.images['hi-res'][0].mobile + ' 300w, ' + data.images['hi-res'][0].mobile2x + ' 600w');
            $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('img.tile-image--primary').attr('alt', data.images['hi-res'][0].alt);
            if (data.images['hi-res'].length > 1) {
                $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('img.tile-image--primary').attr('data-secondary-src', data.images['hi-res'][1].mobile);
                $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('img.tile-image--primary').attr('data-secondary-srcset', data.images['hi-res'][1].mobile + ' 300w, ' + data.images['hi-res'][1].mobile2x + ' 600w');
                $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('img.tile-image--primary').attr('alt', data.images['hi-res'][1].alt);
            } else {
                $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('img.tile-image--primary').attr('data-secondary-srcset', '');
                $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('img.tile-image--primary').attr('data-secondary-src', '');
            }
            $(swatchTrigger).parent().siblings().children()
                .removeClass('selected');
            $(swatchTrigger).addClass('selected');
            // Update tile link to match selected swatch so that appropriate parameters are added to URL for selection on PDP.
            $(swatchTrigger).closest('.product-tile').find('.image-container a').attr('href', $(swatchTrigger).attr('href'));
            $('.product[data-pid="' + $(swatchTrigger).data('pid') + '"]').find('.image-container').spinner().stop();
        });
    });
};

$(function () {
    if ($('.product-detail').length) {
        const queryEl = document.querySelector('[querystring]');
        const queryString = queryEl ? queryEl.getAttribute('querystring') : '';
        const productId = queryString ? new URLSearchParams(queryString).get('pid') : null;

        if (productId) {
            const viewedProducts = JSON.parse(sessionStorage.getItem('viewed_products')) || [];
            if (viewedProducts.length >= 100) {
                viewedProducts.shift();
            }
            if (!viewedProducts.includes(productId)) {
                viewedProducts.push(productId);
                sessionStorage.setItem('viewed_products', JSON.stringify(viewedProducts));
            }
        }
    }

    if ($('.viewed-badge').length) {
        base.markViewedProducts();
    }
});

var productIdViewed = localStorage.getItem('productIdViewed');
if (productIdViewed && $(productIdViewed).length > 0) {
    localStorage.removeItem('productIdViewed');
    $('html, body').animate({
        scrollTop: $(productIdViewed).offset().top - 300
    }, 2000);
}
validateClearResults();
updateSortDropDown();
toggleFilterDrawer();
observeStickyHeader();

module.exports = base;
